var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({
    backgroundImage: 'url(' + require('./assets/background.jpg') + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
  })},[_c('application-loading-component'),_c('v-main',[_c('user-notification-component'),_c('router-view',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }